import { render, staticRenderFns } from "./SettingsOrderMenu.vue?vue&type=template&id=146dc86b&scoped=true&"
import script from "./SettingsOrderMenu.vue?vue&type=script&lang=js&"
export * from "./SettingsOrderMenu.vue?vue&type=script&lang=js&"
import style0 from "./SettingsOrderMenu.vue?vue&type=style&index=0&id=146dc86b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146dc86b",
  null
  
)

export default component.exports